<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    

    
    <g id="Home-2021" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Desktop---1440x1024" transform="translate(-971.000000, -4050.000000)" fill="#DBDBDB" fill-rule="nonzero">
            <g id="bloc-app" transform="translate(-124.000000, 3862.000000)">
                <g id="Group-14" transform="translate(1000.000000, 124.000000)">
                    <g id="Group-10" transform="translate(0.000000, 64.000000)">
                        <polygon id="Star" points="108.5 21 100.564899 25.3262379 102.080369 16.163119 95.660737 9.67376208 104.53245 8.33688104 108.5 0 112.46755 8.33688104 121.339263 9.67376208 114.919631 16.163119 116.435101 25.3262379"></polygon>
                    </g>
                </g>
            </g>
        </g>
    </g>

  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'Star',
    },
    name: {
      type: String,
      required: false,
      default: 'PtcyRatingStarEmpty',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 27 26',
    },
  },
};
</script>

<style scoped>
  
</style>